import { AUTH_BASE_URL } from "../constants/constants";
import { sendRequest } from "../utils/sendAPI";
import { getToken } from "../utils/authUtils";

// Helper: obtain token or throw if missing
const getAuthToken = () => {
  const token = getToken();
  if (!token) throw new Error("Token missing or expired");
  return token;
};

// ---------------- Regions ----------------

export const getRegions = async () => {
  try {
    const token = getAuthToken();
    const url = `${AUTH_BASE_URL}/authentication/locations/regions`;

    const res = await sendRequest({
      url,
      method: "GET",
      token,
    });
    return res;
  } catch (err) {
    console.error("Error fetching regions:", err);
    throw err;
  }
};

// ---------------- Subregions ----------------

export const getSubregionsByRegion = async (regionId) => {
  try {
    const token = getAuthToken();
    const url = `${AUTH_BASE_URL}/authentication/locations/subregions/${regionId}`;

    const res = await sendRequest({
      url,
      method: "GET",
      token,
    });

    return res;
  } catch (err) {
    console.error(`Error fetching subregions for region ${regionId}:`, err);
    throw err;
  }
};

// ---------------- Countries ----------------

export const getCountriesByRegion = async (regionId) => {
  try {
    const token = getAuthToken();
    const url = `${AUTH_BASE_URL}/authentication/locations/countries/by-region/${regionId}`;
    const res = await sendRequest({
      url,
      method: "GET",
      token,
    });

    return res;
  } catch (err) {
    console.error(`Error fetching countries by region ${regionId}:`, err);
    throw err;
  }
};

export const getCountriesBySubregion = async (subregionId) => {
  try {
    const token = getAuthToken();
    const url = `${AUTH_BASE_URL}/authentication/locations/countries/by-subregion/${subregionId}`;

    const res = await sendRequest({
      url,
      method: "GET",
      token,
    });

    return res;
  } catch (err) {
    console.error(`Error fetching countries by subregion ${subregionId}:`, err);
    throw err;
  }
};

// ---------------- States ----------------

export const getStatesByCountry = async (countryId) => {
  try {
    const token = getAuthToken();
    const url = `${AUTH_BASE_URL}/authentication/locations/states/${countryId}`;

    const res = await sendRequest({
      url,
      method: "GET",
      token,
    });

    return res;
  } catch (err) {
    console.error(`Error fetching states for country ${countryId}:`, err);
    throw err;
  }
};

// ---------------- Cities ----------------

export const getCitiesByState = async (stateId) => {
  try {
    const token = getAuthToken();
    const url = `${AUTH_BASE_URL}/authentication/locations/cities/by-state/${stateId}`;

    const res = await sendRequest({
      url,
      method: "GET",
      token,
    });

    return res;
  } catch (err) {
    console.error(`Error fetching cities for state ${stateId}:`, err);
    throw err;
  }
};

export const getCitiesByCountry = async (countryId) => {
  try {
    const token = getAuthToken();
    const url = `${AUTH_BASE_URL}/authentication/locations/cities/by-country/${countryId}`;
    const res = await sendRequest({
      url,
      method: "GET",
      token,
    });

    return res;
  } catch (err) {
    console.error(`Error fetching cities for country ${countryId}:`, err);
    throw err;
  }
};

// ---------------- City Search ----------------

export const searchCitiesByName = async (name, limit = 20) => {
  try {
    const token = getAuthToken();
    const encodedName = encodeURIComponent(name.trim());
    const url = `${AUTH_BASE_URL}/authentication/locations/cities/search?name=${encodedName}&limit=${limit}`;
    const res = await sendRequest({
      url,
      method: "GET",
      token,
    });

    return res;
  } catch (err) {
    console.error(`Error searching for city "${name}":`, err);
    throw err;
  }
};
